/** @jsx h */
import { h } from "hyperapp";
import classNames from "classnames";
import nestable from "hyperapp-nestable";
import { WrappedSvg, mergeStateAction } from "../../utilities/hyperapp";

import plusIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../player/plus-icon.svg";
import tickIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../player/tick-icon.svg";

const initialState = {
  added: false
};

const actions = {
  setAdded: added => mergeStateAction({ added }),
};

const AddToQueueButton = nestable(
  initialState,
  actions,
  (state, actions) => ({ addToQueue, size, item }) => (
    <button
      class={classNames(
        "action",
        `action--${size}`,
        "action--add-to-playlist",
        {
          "action--add-to-playlist-active": state.added
        }
      )}
      aria-label="Add to queue"
      onclick={e => {
        actions.setAdded(true);
        addToQueue(e);
      }}
      ga-on="click,auxclick,contextmenu"
      ga-event-category="audio"
      ga-event-action="add to queue"
      ga-event-label={item.data.title}
    >
      <span class="plus-button">
        <WrappedSvg data={plusIcon} />
      </span>
      <span class="tick-button">
        <WrappedSvg data={tickIcon} />
      </span>
    </button>
  ),
  "add-to-queue-button-"
);

export default AddToQueueButton;
